/**
 * React Query hook for comparing two scans.
 * Cached by scan ID pair so navigating away and back is instant.
 */

import { useQuery } from '@tanstack/react-query';
import { reportsApi, type ComparisonResult } from '@/lib/reports-api';

export function useCompareScans(scan1: string | null, scan2: string | null) {
  return useQuery<ComparisonResult>({
    queryKey: ['compare-scans', scan1, scan2],
    queryFn: () => reportsApi.compareScans(scan1!, scan2!),
    enabled: !!scan1 && !!scan2,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
